import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { ReactComponent as Rectangle } from "../../../assets/previewPage/Rectangle 41943.svg";
import { ReactComponent as Line } from "../../../assets/previewPage/Line.svg";
import { ReactComponent as ContactIcon } from "../../../assets/MainPage/addBlock/countDown/call.svg";
import { ReactComponent as Whatsapp } from "../../../assets/MainPage/addBlock/countDown/whatsapp.svg";
import { ReactComponent as HeaderShareIcon } from "../../../assets/previewPage/headerIcons/headershareicon.svg";
import { ReactComponent as ShareIcon } from "../../../assets/previewPage/headerIcons/PaperPlaneTilt.svg";
import { ReactComponent as LanguageShareIcon } from "../../../assets/previewPage/headerIcons/grommet-icons_language.svg";
import "../../previewPage/dashboardMobilePreview/header.css";
import useLocales from "../../../hooks/useLocales";
import useSettings from "../../../hooks/useSettings";

// import "../../cards/GlobalHeadingStyles.css"; // Import the global heading styles
const baseUrl = process.env.REACT_APP_API_URL;

const HeaderTextStickyCard = ({ item, styles, isSticky }) => {
  const { allLangs, translate, onChangeLang, handleLanguageChange } =
    useLocales();
  const { themeDirection } = useSettings();

  const [coloumValue, setColoumValue] = useState(null);
  const [stylesColoumValue, setStylesColoumValue] = useState(null);
  const [isOpenLangModal, setIsOpenLangModal] = useState(false); // Variable to manage the language modal open/close state
  const [isOpenLangMModal, setIsOpenLangMModal] = useState(false); // Variable to manage the mobile language modal open/close state
  // Using React useRef to create references for DOM elements
  const iconRef = useRef(); // Reference for icon element
  const iconMRef = useRef(); // Reference for mobile icon element
  const modalRef = useRef(); // Reference for modal element
  const modalMRef = useRef(); // Reference for mobile modal element

  // Adding an event listener to handle clicks outside the language modal
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isOpenLangMModal &&
        modalMRef.current &&
        !modalMRef.current.contains(e.target) &&
        !iconMRef.current.contains(e.target)
      ) {
        setIsOpenLangMModal(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpenLangMModal]);

  // Adding an event listener to handle clicks outside the language modal (for desktop)
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isOpenLangModal &&
        modalRef.current &&
        !modalRef.current.contains(e.target) &&
        !iconRef.current.contains(e.target)
      ) {
        setIsOpenLangModal(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpenLangModal]);

  const handleChangeLang = (newLang) => {
    onChangeLang(newLang); // Change the language
    setIsOpenLangModal(false); // Close the language modal
    setIsOpenLangMModal(false); // Close the mobile language modal
  };

  useEffect(() => {
    if (item?.coloum_value) {
      try {
        const parsedColoumValue = JSON.parse(item.coloum_value);
        setColoumValue(parsedColoumValue);
        if (parsedColoumValue?.avatar_outline) {
          const parsedStylesColoumValue = JSON.parse(
            parsedColoumValue.avatar_outline
          );
          setStylesColoumValue(parsedStylesColoumValue);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, [item]);

  // const applyClassesToHtml = (html) => {
  //   if (!html) return '';
  //   // Regular expression to match opening <h1>, <h2>, <h3>, <h4>, <h5>, <h6> tags
  //   const regex = /<h([1-6])[^>]*>/g;

  //   // Replace all opening <hX> tags with the corresponding class
  //   const updatedHtml = html.replace(
  //     regex,
  //     (match, capturedGroup) =>
  //       `<h${capturedGroup} class='custom-h${capturedGroup.toLowerCase()}'>`
  //   );

  //   return updatedHtml;
  // };

  const alignmentClass =
    coloumValue?.alignment === "left"
      ? "items-start"
      : coloumValue?.alignment === "right"
      ? "items-end"
      : "items-center";

  const justifyClass =
    coloumValue?.alignment === "left"
      ? "justify-start"
      : coloumValue?.alignment === "right"
      ? "justify-end"
      : "justify-center";

  const backgroundImageUrl = coloumValue?.backGroundImage
    ? baseUrl + "/profile/" + coloumValue?.backGroundImage
    : "";

  const calculateMarginTop = (size) => {
    switch (size) {
      case "75x75":
        return "mt-[36px]";
      case "100x100":
        return "mt-[48px]";
      case "125x125":
        return "mt-[59px]";
      case "150x150":
        return "mt-[70px]";
      default:
        return "mt-[36px]";
    }
  };

  const marginTopClass = calculateMarginTop(coloumValue?.avatar_size);

  const calculateTop = (size) => {
    switch (size) {
      case "75x75":
        return "top-[102px]";
      case "100x100":
        return "top-[88px]";
      case "125x125":
        return "top-[74px]";
      case "150x150":
        return "top-[60px]";
      default:
        return "top-[102px]";
    }
  };

  const TopClass = calculateTop(coloumValue?.avatar_size);

  const truncateTitle = (title) => {
    if (title?.length > 20) {
      return title.slice(0, 20) + "...";
    }
    return title;
  };

  return (
    <div className={`flex flex-col w-full  ${isSticky ? "sticceky" : ""}`}>
      {backgroundImageUrl ? (
        <div
          className={`flex bg-cover bg-center bg-no-repeat w-full h-[80px] smm:h-[100px] object-cover relative`}
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
          }}
        >
          <div
            className={`flex px-[30px] md:max-w-[690px] w-full`}
            style={{
              margin: "0 auto",
            }}
          >
            <div className="flex justify-start items-center flex-grow gap-[8px] smm:gap-[16px]">
              <img
                style={{
                  borderStyle: stylesColoumValue?.outline_style,
                  borderColor: stylesColoumValue?.outline_colour,
                  gap: "0px",
                  opacity: "0px",
                }}
                className={` object-cover  smm:max-h-[80px] smm:min-h-[80px] smm:h-[80px] smm:max-w-[80px] smm:min-w-[80px] smm:w-[80px] max-h-[46px] min-h-[46px] h-[46px] max-w-[46px] min-w-[46px] w-[46px] ${
                  coloumValue?.avatar_shape
                    ? coloumValue?.avatar_shape === "rounded"
                      ? "rounded-lg"
                      : coloumValue?.avatar_shape === "circle"
                      ? "rounded-full"
                      : "rounded-none"
                    : coloumValue?.avatar_shape === "rounded"
                    ? "rounded-lg"
                    : coloumValue?.avatar_shape === "circle"
                    ? "rounded-full"
                    : "rounded-none"
                } ${
                  stylesColoumValue
                    ? `${
                        stylesColoumValue?.outline_width === "8px"
                          ? "border-8"
                          : stylesColoumValue?.outline_width === "4px"
                          ? "border-4"
                          : stylesColoumValue?.outline_width === "2px"
                          ? "border-2"
                          : "border"
                      } border-${stylesColoumValue?.outline_style} border-[${
                        stylesColoumValue?.outline_colour
                      }]`
                    : ""
                }`}
                src={`${
                  coloumValue?.image
                    ? baseUrl + "/profile/" + coloumValue?.image
                    : ""
                }`}
                alt="avatar"
                title="Avatar"
              />
              <div className="flex flex-col items-start">
                <h1 className={`text-white text-small2 smm:text-body_copy2`}>
                  {truncateTitle(coloumValue?.pageName)}
                </h1>
                <h3 className="text-small3 smm:text-small1 text-main_color text-center mt-[2px] smm:mt-[5px]">
                  {truncateTitle(coloumValue?.pageTitle)}
                </h3>
              </div>
            </div>
            <div className="flex justify-end mt-[26px] relative">
              <div
                className="flex"
                style={{
                  gap: "8px",
                  opacity: "0px",
                }}
              >
                <ShareIcon className="cursor-pointer" />
                <HeaderShareIcon className="cursor-pointer" />
                <LanguageShareIcon
                  onClick={() => setIsOpenLangMModal(!isOpenLangMModal)}
                  className="cursor-pointer"
                  ref={iconMRef}
                />
                {isOpenLangMModal && (
                  <div
                    ref={modalMRef}
                    className={`absolute rounded-xl bg-white dark:bg-dark-secondary top-[30px] ${
                      themeDirection === "rtl"
                        ? "right-[34px]"
                        : "-right-[13px]"
                    }`}
                  >
                    <div className="flex relative rounded-xl w-max flex-col p-2 gap-2">
                      <div className="absolute h-3 w-3 bg-white  dark:bg-dark-secondary -top-1.5 right-4 rotate-45"></div>
                      {allLangs.map((lang) => {
                        return (
                          <div
                            key={lang?.value}
                            onClick={() => handleChangeLang(lang?.value)}
                            className={`p-1 px-2 hover:bg-gray-100 dark:hover:bg-dark-primary cursor-pointer rounded-lg ${
                              themeDirection === "rtl" ? "flex-row-reverse" : ""
                            } flex items-center gap-2 min-w-fit`}
                          >
                            <p className="whitespace-nowrap dark:text-color_v1_dark">
                              {lang?.label}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`flex w-full h-[80px] smm:h-[100px] relative`}
          style={{ background: "#294776" }}
        >
          <div
            className={`flex px-[30px] md:max-w-[690px] w-full`}
            style={{
              margin: "0 auto",
            }}
          >
            <div className="flex justify-start items-center flex-grow gap-[8px] smm:gap-[16px]">
              <img
                style={{
                  borderStyle: stylesColoumValue?.outline_style,
                  borderColor: stylesColoumValue?.outline_colour,
                  gap: "0px",
                  opacity: "0px",
                }}
                className={` object-cover  smm:max-h-[80px] smm:min-h-[80px] smm:h-[80px] smm:max-w-[80px] smm:min-w-[80px] smm:w-[80px] max-h-[46px] min-h-[46px] h-[46px] max-w-[46px] min-w-[46px] w-[46px] ${
                  coloumValue?.avatar_shape
                    ? coloumValue?.avatar_shape === "rounded"
                      ? "rounded-lg"
                      : coloumValue?.avatar_shape === "circle"
                      ? "rounded-full"
                      : "rounded-none"
                    : coloumValue?.avatar_shape === "rounded"
                    ? "rounded-lg"
                    : coloumValue?.avatar_shape === "circle"
                    ? "rounded-full"
                    : "rounded-none"
                } ${
                  stylesColoumValue
                    ? `${
                        stylesColoumValue?.outline_width === "8px"
                          ? "border-8"
                          : stylesColoumValue?.outline_width === "4px"
                          ? "border-4"
                          : stylesColoumValue?.outline_width === "2px"
                          ? "border-2"
                          : "border"
                      } border-${stylesColoumValue?.outline_style} border-[${
                        stylesColoumValue?.outline_colour
                      }]`
                    : ""
                }`}
                src={`${
                  coloumValue?.image
                    ? baseUrl + "/profile/" + coloumValue?.image
                    : ""
                }`}
                alt="avatar"
                title="Avatar"
              />
              <div className="flex flex-col items-start">
                <h1 className={`text-white text-small2 smm:text-body_copy2`}>
                  {truncateTitle(coloumValue?.pageName)}
                </h1>
                <h3 className="text-small3 smm:text-small1 text-main_color text-center mt-[2px] smm:mt-[5px]">
                  {truncateTitle(coloumValue?.pageTitle)}
                </h3>
              </div>
            </div>
            <div className="flex justify-end mt-[26px] relative">
              <div
                className="flex"
                style={{
                  gap: "8px",
                  opacity: "0px",
                }}
              >
                <ShareIcon className="cursor-pointer" />
                <HeaderShareIcon className="cursor-pointer" />
                <LanguageShareIcon
                  onClick={() => setIsOpenLangMModal(!isOpenLangMModal)}
                  className="cursor-pointer"
                  ref={iconMRef}
                />
                {isOpenLangMModal && (
                  <div
                    ref={modalMRef}
                    className={`absolute rounded-xl bg-white dark:bg-dark-secondary top-[30px] ${
                      themeDirection === "rtl"
                        ? "right-[34px]"
                        : "-right-[13px]"
                    }`}
                  >
                    <div className="flex relative rounded-xl w-max flex-col p-2 gap-2">
                      <div className="absolute h-3 w-3 bg-white  dark:bg-dark-secondary -top-1.5 right-4 rotate-45"></div>
                      {allLangs.map((lang) => {
                        return (
                          <div
                            key={lang?.value}
                            onClick={() => handleChangeLang(lang?.value)}
                            className={`p-1 px-2 hover:bg-gray-100 dark:hover:bg-dark-primary cursor-pointer rounded-lg ${
                              themeDirection === "rtl" ? "flex-row-reverse" : ""
                            } flex items-center gap-2 min-w-fit`}
                          >
                            <p className="whitespace-nowrap dark:text-color_v1_dark">
                              {lang?.label}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderTextStickyCard;
